import React from 'react';
import PropTypes from 'prop-types';

import CompanyForm from './company';
import CustomFields from './custom_fields';
import ManagedInput from 'components/form/managed_input';
import PersonForm from './person';
import TagsInput from 'bundles/crm/tags/input';
import TagsInputLabel from 'bundles/crm/tags/input/contact_form_label';
import typeOptions from 'bundles/backoffice/contacts/type_options';

class ContactForm extends React.Component {
  static propTypes = {
    allowSavingPrivateContacts: PropTypes.bool,
    allowTagging: PropTypes.bool,
    contact: PropTypes.shape({
      contactType: PropTypes.string.isRequired,
      crmTags: PropTypes.array.isRequired,
      id: PropTypes.number,
      visibility: PropTypes.string,
    }).isRequired,
    contactType: PropTypes.string,
    extraFormSections: PropTypes.node,
    multipleBusinesses: PropTypes.bool,
    requestPermissions: PropTypes.bool,
    onChange: PropTypes.func.isRequired
  }

  render() {
    return <div className="d-flex flex-column gap-6">
      {this.props.contactType || this.props.contact.id ? null : this.renderType()}
      {this.props.requestPermissions && this.renderPermissionsInputs()}
      {this.props.allowTagging && this.renderTags()}
      {this.props.contact.contactType === 'business' ? this.renderCompanyForm() : this.renderPersonForm()}
      <CustomFields contact={this.props.contact} onChange={this.props.onChange} />
    </div>;
  }

  renderType() {
    return (
      <div className="form-vertical-field-container">
        <h6>Type</h6>
        <ManagedInput
          aria-label="contactType"
          name="contactType"
          options={typeOptions}
          type="radioGroup"
          value={this.props.contact.contactType}
          onChange={this.props.onChange}
        />
      </div>
    );
  }

  renderPermissionsInputs() {
    const options = [];
    options.push({ label: 'Public', value: 'public' });

    if (this.props.allowSavingPrivateContacts) {
      options.push({ label: 'Private', value: 'private' });
    }

    if (options.length === 1) {
      return null;
    }

    return (
      <div className="form-vertical-field-container">
        <h6>Permissions</h6>
        <ManagedInput
          name="visibility"
          options={options}
          required
          type="radioGroup"
          value={this.props.contact.visibility}
          onChange={this.props.onChange}
        />
      </div>
    );
  }

  renderTags() {
    return (
      <div>
        <TagsInputLabel />
        <TagsInput
          value={this.props.contact.crmTags}
          onValueChange={crmTags => this.props.onChange({ crmTags })}
        />
      </div>
    );
  }

  renderCompanyForm() {
    return (
      <CompanyForm
        contact={this.props.contact}
        extraSections={this.props.extraFormSections}
        onChange={this.props.onChange}
      />
    );
  }

  renderPersonForm() {
    return (
      <PersonForm
        allowSavingPrivateContacts={this.props.allowSavingPrivateContacts}
        contact={this.props.contact}
        extraSections={this.props.extraFormSections}
        multipleBusinesses={this.props.multipleBusinesses}
        onChange={this.props.onChange}
      />
    );
  }
}

export default ContactForm;
